import { useTheme } from '@mui/material'

import Button, { ButtonProps } from 'app/components/base/Button'

interface GradientButtonProps extends ButtonProps {}

const GradientButton: RFC<GradientButtonProps> = ({
  children,
  sx,
  ...props
}) => {
  const { palette } = useTheme()

  return (
    <Button
      variant="contained"
      sx={{
        background: `linear-gradient(90deg, ${palette.secondary.light} 0%, ${palette.secondary.main} 100%)`,
        color: 'text.primary',
        border: 'none',

        '&:hover': { opacity: 0.8 },

        ...sx
      }}
      {...props}
    >
      {children}
    </Button>
  )
}

export default GradientButton
